import * as actionTypes from "./actionTypes";
import * as types from "./types";

// GET Loaders 

const initLoadersListState: types.LoaderListState = {
    pending: false,
    loaders: {} as types.IDataLoaderList,
    error: null,
};

export const LoadersListReducer = (state = initLoadersListState, action: types.LoadersActions) => {
    switch (action.type) {
        case actionTypes.FETCH_LOADERS_LIST_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.FETCH_LOADERS_LIST_SUCCESS:
            return {
                ...state,
                pending: false,
                loaders: action.payload.loaders,
                error: null,
            };
        case actionTypes.FETCH_LOADERS_LIST_FAILURE:
            return {
                ...state,
                pending: false,
                loaders: {} as types.IDataLoaderList,
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }
};

// GET Loader Details

const initLoaderState: types.LoaderDetailsState = {
    pending: false,
    loaderDetails: null,
    error: null,
};

export const LoaderDetailsReducer = (state = initLoaderState, action: types.LoaderDetailsActions) => {
    switch (action.type) {
        case actionTypes.FETCH_LOADER_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.FETCH_LOADER_SUCCESS:
            return {
                ...state,
                pending: false,
                loaderDetails: action.payload.loaderDetails,
                error: null,
            };
        case actionTypes.FETCH_LOADER_FAILURE:
            return {
                ...state,
                pending: false,
                loaderDetails: null,
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }
};


// DELETE Loader Details

const initDeleteLoaderState: types.IDeleteLoaderState = {
    pending: false,
    deleteStatus: null,
    error: null,
};

export const DeleteLoaderReducer = (state = initDeleteLoaderState, action: types.DeleteLoaderActions) => {
    switch (action.type) {
        case actionTypes.DELETE_LOADER_REQUEST:
            return {
                ...state,
                success: null,
                pending: true,
            };
        case actionTypes.DELETE_LOADER_SUCCESS:
            return {
                ...state,
                pending: false,
                deleteStatus: action.payload.deleteStatus,
                error: null,
            };
        case actionTypes.DELETE_LOADER_FAILURE:
            return {
                ...state,
                pending: false,
                success: null,
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }
};


// POST Data Loader

const initialStateDataLoader: types.IPostDataLoaderState = {
    pending: false,
    dataLoader: null,
    error: null,
};

export const PostDataLoaderReducer = (state = initialStateDataLoader, action: types.PostDataLoaderActions) => {

    switch (action.type) {
        case actionTypes.POST_DATALOADER_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.POST_DATALOADER_SUCCESS:
            return {
                ...state,
                pending: false,
                dataLoader: action.payload.dataLoader,
                error: null,
            };
        case actionTypes.POST_DATALOADER_FAILURE:
            return {
                ...state,
                pending: false,
                dataLoader: null,
                error: action.payload.error,
            };
        case actionTypes.POST_DATALOADER_RESET:
            return {
                ...state,
                dataLoader: null,
            };
        default:
            return {
                ...state,
            };
    }

};


// PUT Data Loader

const initialStatePutDataLoader: types.IPutDataLoaderState = {
    pending: false,
    dataLoader: null,
    error: null,
};

export const PutDataLoaderReducer = (state = initialStatePutDataLoader, action: types.PutDataLoaderActions) => {
    switch (action.type) {

        case actionTypes.PUT_DATALOADER_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.PUT_DATALOADER_SUCCESS:
            return {
                ...state,
                pending: false,
                dataLoader: action.payload.dataLoader,
                error: null,
            };
        case actionTypes.PUT_DATALOADER_FAILURE:
            return {
                ...state,
                pending: false,
                dataLoader: null,
                error: action.payload.error,
            };
            case actionTypes.PUT_DATALOADER_RESET:
                return {
                    ...state,
                    dataLoader: false,
                };
        default:
            return {
                ...state,
            };
    }

};


// Loader Status
const initLoaderStatusState: types.ILoaderStatusState = {
    pending: false,
    loaderStatus: null,
    error: null,
  };
  
  export const LoaderStatusReducer = (
    state = initLoaderStatusState,
    action: types.LoaderStatusActions
  ) => {
    switch (action.type) {
      case actionTypes.FETCH_LOADER_STATUS_REQUEST:
        return {
          ...state,
          pending: true,
        };
      case actionTypes.FETCH_LOADER_STATUS_SUCCESS:
        return {
          ...state,
          pending: false,
          loaderStatus: action.payload.loaderStatus,
          error: null,
        }
      case actionTypes.FETCH_LOADER_STATUS_FAILURE:
        return {
          ...state,
          pending: false,
          loaderStatus: null,
          error: action.payload.error,
        };
      default:
        return {
          ...state,
        };
    }
  };